module.exports = __webpack_public_path__ + "assets/img/share-btn.b99eacfd.png";